import { Readings, Meter, Sensors } from "../../api";
import { auth, db } from "../../plugins/firebase";
import moment from "moment";
import firebase from "firebase/app";

const state = {
  meters: [],
  capacityMeters: [],
  currMeters: [],
  collection: null,
  lastReadings: null,
  userInfo: null,
  key: "94260d97055e949eada6d5d9b569c49a",
  metersAPI: [],
  meterStatus: false,
  watts: [],
  arrayMeterLinks: [],
  comments: [],
  allComments: [],
  metersON: null,
  metersUP: null,
  metersDOWN: null,
  metersOFF: null,
  metersOUT: null,
  arrayON: [],
  arrayUP: [],
  arrayDOWN: [],
  arrayOFF: [],
  arrayOUT: [], //Length will determine qty
  arrayTemps: [],
  rangeTemps: [],
  rangeArrayTemps: [],
  arrayLights: [],
  rangeLights: [],
  rangeArrayLights: [],
  arrayHumids: [],
  rangeHumids: [],
  rangeArrayHumids: [],
  groupMeters: [],
  rangeArraySignals: [],
  signals: [0, 60, 65, 70, 75, 80, 85, 90, 95, 100],
  arrayStatus: [],
  rangeArrayWatts: [],
  signalData: [],
  token: "",
  lastHour: "",
};

const getters = {
  getMeter: (state) => (meter) =>
    state.meters.find((m) => m.name === meter || m.circuit === meter),
  getMeterData: (state) => (meter) =>
    state.meters.find((m) => m.name === meter || m.circuit === meter).data,
  getLastReading: (state) => (meter) =>
    state.lastReadings.find((m) => m.meter === meter),
  getAll: (state) =>
    state.meters.map((m) => ({ name: m.name, circuit: m.circuit })),
  getLocations: (state) => state.meters.map((m) => m.location),
  getGroup: (state) => (group) => state.groupMeters.find((m) => m.id === group),
};

const actions = {
  async setCollectionDb({ state, rootState, commit, dispatch }) {
    // console.log('setting');
    return new Promise(async (resolve, reject) => {
      if (auth.currentUser) {
        // console.log('inicio de los tiempos...');
        // console.log(1);
        // console.log(rootState.user.profile);
        await dispatch("resetMeters");
        // console.log(2);
        await commit("UPDATE_USER_INFO", rootState.user.profile.account);
        // console.log(3);
        let ud = await state.userInfo.get();
        // console.log(ud.data());
        commit("UPDATE_TOKEN", ud.data().token);
        await commit("UPDATE_COLLECTION", rootState.user.profile.account);
        // console.log(4);
        await dispatch("fetchUserMeters");
        // if(state.meters.length > 0) await dispatch('lastReadings')
        await dispatch("lastReadings");
        // console.log(5);
        await dispatch("fetchUserGroups");
        // console.log(6);
        await dispatch("setGroupsinFB");
        // console.log(7);

        return resolve();
      } else {
        commit("UPDATE_COLLECTION");
        commit("SET_METERS", []);
        return resolve();
      }
    });
  },
  async fetchUserMeters({ commit }) {
    return new Promise(async (resolve, reject) => {
      try {
        let response = await db.collection(state.collection).get();
        let arrOriginal = response.docs.map((m) => m.data());
        let collator = new Intl.Collator(undefined, {
          numeric: true,
          sensitivity: "base",
        });
        let myArray2 = response.docs.map((m) => m.data().circuit);
        let metersOrdered2 = myArray2.sort(collator.compare);
        let nwArray = [];
        for (let index = 0; index < metersOrdered2.length; index++) {
          let element = metersOrdered2[index];
          let e = arrOriginal.find((m) => m.circuit === element);
          nwArray.push(e);
        }
        commit("SET_METERS", nwArray);
        // commit('SET_METERS', [])
        return resolve();
      } catch (error) {
        commit("SET_METERS", []);
        return reject({ message: "¡Ops! Ocurrio un error" });
      }
    });
  },
  async updateMeterFromApi({ state, commit }, meter_id) {
    const meter = state.meters.find((m) => m.name === meter_id);
    if (!meter) return;
    let info = await db.collection(state.collection).doc(meter.name).get();
    let dt = info.data().device_type;
    return new Promise((resolve, reject) => {
      Meter.get({ id: meter.name, key: meter.key })
        .then((response) => {
          const { data } = response;
          if (dt === "smart_node") {
            let lvl = data.level === undefined ? 0 : data.level;
            db.doc(`${state.collection}/${data.name}`).update({
              node_level: lvl,
            });
          }
          commit("UPDATE_METER_API", data);
          resolve();
        })
        .catch((err) => reject(err));
    });
  },
  async getSimIDs({ state, commit }, meters) {
    let updatedMeters = [];
    for (let index = 0; index < meters.length; index++) {
      let meter = meters[index];
      let name = meter.circuit;
      let mInfo = await Meter.get({ id: meter.name, key: meter.key });
      let sim = mInfo.data.sim_id;
      let obj = { name: name, simID: sim };
      updatedMeters.push(obj);
    }
    const options = {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization:
          "Bearer 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",
      },
    };

    await fetch(
      "https://api.1nce.com/management-api/v1/sims/8988228066602582431/status",
      options
    )
      .then((response) => response.json())
      .then((response) => console.log(response))
      .catch((err) => console.error(err));
  },
  async fetchAPIstatus({ state, commit }, meter_id) {
    const meter = state.meters.find((m) => m.name === meter_id);
    if (!meter) return;
    return new Promise((resolve, reject) => {
      Meter.get({ id: meter.name, key: meter.key })
        .then((response) => {
          const { data } = response;
          commit("UPDATE_METER_STATUS", data);
          resolve();
        })
        .catch((err) => reject(err));
    });
  },
  async checkMeter({ state, commit }, gateway) {
    return new Promise(async (resolve, reject) => {
      try {
        let gw = state.meters.find((m) => m.gateway.id == gateway.id);
        if (gw) resolve();
      } catch (error) {
        console.log(error);
        reject({ message: "¡Ops! Ocurrio un error" });
      }
    });
  },
  async addMeters({ state, commit }, data) {
    return new Promise(async (resolve, reject) => {
      try {
        let gateway = state.meters.find((m) => m.gateway.id == data.gateway.id);
        if (gateway) reject({ message: "Gateway ya registrado" });

        let batch = db.batch();
        let meters = data.meters.map((m) => {
          let meter = {
            name: m.name,
            key: m.key,
            nlines: m.nlines,
            circuit: m.circuit,
            gateway: data.gateway,
            capacity: m.capacity,
            fare: m.fare,
            device_type: m.deviceType,
          };

          if (
            meter.device_type === null ||
            meter.device_type === undefined ||
            meter.device_type === ""
          )
            meter.device_type = "smart_controller";
          else {
            let dt = meter.device_type.toLowerCase();
            meter.device_type = `smart_${dt}`;
            if (dt === "node") {
              meter.node_level = m.level;
            }
          }

          // console.log(meter);

          meter.location = new firebase.firestore.GeoPoint(
            parseFloat(m.latitude),
            parseFloat(m.longitude)
          );

          batch.set(db.doc(`${state.collection}/${m.name}`), meter);
          return meter;
        });

        await batch.commit();

        commit("ADD_METERS", meters);
        resolve();
      } catch (error) {
        console.log(error);
        reject({ message: "¡Ops! Ocurrio un error" });
      }
    });
  },
  async editMeter({ state, commit }, meter_updated) {
    return new Promise(async (resolve, reject) => {
      try {
        let index = state.meters.findIndex((m) => m.name == meter_updated.name);
        if (index < 0) reject({ message: "Medidor no registrado" });

        meter_updated.location = new firebase.firestore.GeoPoint(
          parseFloat(meter_updated.latitude),
          parseFloat(meter_updated.longitude)
        );

        let lat = parseFloat(meter_updated.latitude);
        let lng = parseFloat(meter_updated.longitude);

        const d = await fetch(
          `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${process.env.VUE_APP_FB_API_KEY}`
        );
        const d_json = await d.json();
        let address = null;
        let gMapLink;
        if (d_json.hasOwnProperty("plus_code")) {
          address = d_json.plus_code.global_code;
          let arr_add = address.split("");
          let arr_new = [];
          for (let index = 0; index < arr_add.length; index++) {
            const element = arr_add[index];
            if (element != "+") {
              arr_new.push(element);
            } else {
              let prov = "%2B";
              arr_new.push(prov);
            }
          }
          let arr_join = arr_new.join("");
          gMapLink = `https://www.google.com/maps/place/${arr_join}`;
          address = gMapLink;
        } else {
          address = "N/A";
        }

        delete meter_updated.longitude;
        delete meter_updated.latitude;

        meter_updated.link = address;

        await db.doc(`${state.collection}/${meter_updated.name}`).update({
          circuit: meter_updated.circuit,
          location: meter_updated.location,
          capacity: meter_updated.capacity,
          fare: meter_updated.fare,
          link: gMapLink,
        });

        let lname = state.meters[index].name;
        let arrlinks = state.arrayMeterLinks;
        let arrlinks2 = arrlinks.filter((l) => l.id != lname);
        let objlink = { name: meter_updated.name, id: lname, url: address };
        arrlinks2.push(objlink);
        commit("SET_ARRAY_LINKS", arrlinks2);
        commit("UPDATE_METER", { meter: meter_updated, index });
        resolve();
      } catch (error) {
        reject();
      }
    });
  },
  async checkIssue({ state, commit }, data) {
    let { meter_id, issue } = data;
    return new Promise(async (resolve, reject) => {
      try {
        let index = state.meters.findIndex((m) => m.name == meter_id);
        let response = await db
          .collection(state.collection)
          .doc(meter_id)
          .update({
            issue: issue,
          });
        commit("REPORT_ISSUE", { meter_id, index, issue });
        resolve();
      } catch (error) {
        reject();
      }
    });
  },
  async uncheckIssue({ state, commit }, data) {
    let { meter_id, issue } = data;
    return new Promise(async (resolve, reject) => {
      try {
        let response = await db
          .collection(state.collection)
          .doc(meter_id)
          .update({
            issue: issue,
          });
        commit("REPORT_ISSUE", { meter_id, index, issue });
        resolve();
      } catch (error) {
        reject();
      }
    });
  },
  async deleteMeter({ state, commit }, meter_id) {
    return new Promise(async (resolve, reject) => {
      try {
        let m = state.meters.find((m) => m.circuit === meter_id);
        await db.collection(state.collection).doc(m.name).delete();
        commit("DELETE_METER", meter_id);
        resolve();
      } catch (error) {
        reject();
      }
    });
  },
  controlMeter({ commit }, payload) {
    const { meter, control, fotocelda } = payload;
    return new Promise(async (resolve, reject) => {
      try {
        await Meter.control(meter, { control, fotocelda });
        commit("UPDATE_METER_CONTROL", payload);
        return resolve({ message: "Exito" });
      } catch (error) {
        return reject({ message: "¡Ops! Ocurrio un error" });
      }
    });
  },
  scheduleMeter({ commit }, payload) {
    const { meter, data } = payload;
    return new Promise(async (resolve, reject) => {
      try {
        await Meter.schedule(meter, data);
        commit("UPDATE_METER_SCHEDULE", { meter, ...data });
        return resolve({ message: "Exito" });
      } catch (error) {
        console.log(error);
        return reject({ message: "¡Ops! Ocurrio un error" });
      }
    });
  },
  activeSuntime({ commit }, payload) {
    const { meter, data } = payload;
    return new Promise(async (resolve, reject) => {
      try {
        await Meter.suntime(meter, data);
        commit("UPDATE_METER_SUNTIME", { meter, data });
        return resolve({ message: "Exito" });
      } catch (error) {
        console.log(error);
        return reject({ message: "¡Ops! Ocurrio un error" });
      }
    });
  },
  fetchUserGroups({ state, commit }) {
    return new Promise(async (resolve, reject) => {
      try {
        let data = state.meters;
        let arrayGroups = [];
        let groupNames = [];
        let finalGroups = [];
        for (let index = 0; index < data.length; index++) {
          let element = data[index];
          if (element) {
            let circuit = state.meters.find((m) => m.name === element.name);
            if (circuit.group != undefined) {
              arrayGroups.push(circuit);
            }
          }
        }
        if (arrayGroups.length) {
          for (let index = 0; index < arrayGroups.length; index++) {
            groupNames.push(arrayGroups[index].group);
          }
          let collator = new Intl.Collator(undefined, {
            numeric: true,
            sensitivity: "base",
          });
          let groupNamesOrdered = groupNames.sort(collator.compare);
          let newArrNames = [];
          newArrNames.push(groupNamesOrdered[0]);
          for (let index = 0; index < groupNamesOrdered.length - 1; index++) {
            if (groupNamesOrdered[index] != groupNamesOrdered[index + 1])
              newArrNames.push(groupNamesOrdered[index + 1]);
          }
          for (let index = 0; index < newArrNames.length; index++) {
            const element = newArrNames[index];
            let id = element.toLowerCase().replace(/\s+/g, "");
            let arr = [];
            arrayGroups.forEach((m) => {
              if (m.group === element) {
                arr.push(m);
              }
            });
            finalGroups.push({
              name: element,
              id: id,
              meters: arr,
              control: false,
              photocell: false,
              suntime: false,
              timeON: "00:00",
              timeOFF: "00:00",
            });
          }
          commit("SET_GROUPS", finalGroups);
        } else {
          arrayGroups.push({
            name: "My First Group",
            id: "myfirstgroup",
            meters: [],
            control: false,
            photocell: false,
            suntime: false,
            timeON: "00:00",
            timeOFF: "00:00",
          });
          commit("SET_GROUPS", arrayGroups);
        }
        return resolve();
      } catch (error) {
        return reject();
      }
    });
  },
  async setGroupsinFB({ rootState, state }) {
    let groups = state.groupMeters;
    if (groups.length > 1) {
      for (let index = 0; index < groups.length; index++) {
        const element = groups[index];
        let groupData = await db
          .doc(`users/${rootState.user.profile.account}/groups/${element.name}`)
          .get();
        groups[index].control = groupData.data().control;
        groups[index].photocell = groupData.data().photocell;
        groups[index].suntime = groupData.data().suntime;
        groups[index].timeON = groupData.data().timeON;
        groups[index].timeOFF = groupData.data().timeOFF;
      }
    } else {
      if (groups[0].name === "My First Group") {
        await db
          .doc(
            `users/${rootState.user.profile.account}/groups/${groups[0].name}`
          )
          .set({
            name: groups[0].name,
            control: groups[0].control,
            photocell: groups[0].photocell,
            suntime: groups[0].suntime,
            timeON: groups[0].timeON,
            timeOFF: groups[0].timeOFF,
          });
      } else {
        let groupData = await db
          .doc(
            `users/${rootState.user.profile.account}/groups/${groups[0].name}`
          )
          .get();
        groups[0].control = groupData.data().control;
        groups[0].photocell = groupData.data().photocell;
        groups[0].suntime = groupData.data().suntime;
        groups[0].timeON = groupData.data().timeON;
        groups[0].timeOFF = groupData.data().timeOFF;
      }
    }
  },
  lastReadings({ state, commit }) {
    return new Promise(async (resolve, reject) => {
      try {
        let { data } = await Readings.last(state.meters.map((m) => m.name));
        commit(
          "UPDATE_LAST_READS",
          data.map((record) => record[0])
        );
        let arrayWatts = [];
        let arrayValues = [];
        let arrDevWatts = [];
        let arrDevSignals = [];
        let array_ON = [];
        let array_UP = [];
        let array_DOWN = [];
        let array_OFF = [];
        let array_OUT = [];
        let userData = await state.userInfo.get();
        // console.log(userData.data());
        let minToDgr = userData.data().minutesToDanger;
        let m_ON = 0;
        let m_UP = 0;
        let m_DOWN = 0;
        let m_OFF = 0;
        let m_OUT = 0;
        let arrayLinks = [];
        let arrayGroups = [];
        let groupNames = [];
        let finalGroups = [];
        // console.log(data);
        for (let index = 0; index < data.length; index++) {
          let element = data[index][0];
          // console.log(element);
          if (element != undefined) {
            let time =
              new Date().getTime() - new Date(element.timestamp).getTime();
            let m = Math.abs(
              element.lines.reduce((suma, l) => suma + l.watts, 0).toFixed(2)
            );
            // console.log(m);
            let circuit = state.meters.find((m) => m.name === element.meter);
            // console.log(circuit);
            let device = circuit.name; // nombre del medidor
            let obw = { meter: device, watts: m };
            arrDevWatts.push(obw);
            let rssi = Math.abs(element.status.rssi);
            let obr = { meter: device, signal: rssi };
            arrDevSignals.push(obr);
            if (circuit.link != undefined) {
              let obj = {
                name: circuit.circuit,
                url: circuit.link,
                id: circuit.name,
              };
              arrayLinks.push(obj);
            } else {
              let lat = circuit.location.latitude;
              let lng = circuit.location.longitude;
              const d = await fetch(
                `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${process.env.VUE_APP_FB_API_KEY}`
              );
              const d_json = await d.json();
              let address = null;
              let obj = {};
              if (d_json.hasOwnProperty("plus_code")) {
                address = d_json.plus_code.global_code;
                let arr_add = address.split("");
                let arr_new = [];
                for (let index = 0; index < arr_add.length; index++) {
                  const element = arr_add[index];
                  if (element != "+") {
                    arr_new.push(element);
                  } else {
                    let prov = "%2B";
                    arr_new.push(prov);
                  }
                }
                let arr_join = arr_new.join("");
                let gMapLink = `https://www.google.com/maps/place/${arr_join}`;
                obj = {
                  name: circuit.circuit,
                  url: gMapLink,
                  id: circuit.name,
                };
                arrayLinks.push(obj);
              } else {
                address = "N/A";
                obj = { name: circuit.circuit, url: address };
                arrayLinks.push(obj);
              }

              await db
                .doc(`${state.collection}/${circuit.name}`)
                .update({ link: obj.url });
            }

            if (circuit.device_type == undefined) {
              await db
                .doc(`${state.collection}/${circuit.name}`)
                .update({ device_type: "smart_controller" });
            }

            let limOff = Number(circuit.capacity);
            let limUp = limOff + limOff * 0.1;
            let limDown = limOff - limOff * 0.1;
            let limReg = limOff - limOff * 0.95;
            if (minToDgr * 60 * 1000 < time) {
              m_OUT += 1;
              let e_OUT = state.meters.find((m) => m.name === element.meter);
              // console.log(e_OUT);
              array_OUT.push(e_OUT);
            } else if (m < limReg) {
              m_OFF += 1;
              let e_OFF = state.meters.find((m) => m.name === element.meter);
              // console.log(e_OFF);
              array_OFF.push(e_OFF);
            } else if (m >= limReg && m < limDown) {
              m_DOWN += 1;
              m_ON += 1;
              let e_DOWN = state.meters.find((m) => m.name === element.meter);
              // console.log(e_DOWN);
              array_DOWN.push(e_DOWN);
              array_ON.push(e_DOWN);
            } else if (m >= limDown && m < limUp) {
              m_ON += 1;
              let e_ON = state.meters.find((m) => m.name === element.meter);
              array_ON.push(e_ON);
            } else if (m >= limUp) {
              m_UP += 1;
              m_ON += 1;
              let e_UP = state.meters.find((m) => m.name === element.meter);
              array_UP.push(e_UP);
              array_ON.push(e_UP);
            }
            arrayWatts.push(m);
          }
        }
        commit("SET_DATA_WATTS", arrDevWatts);
        commit("SET_DATA_SIGNAL", arrDevSignals);
        commit("SET_ACTUAL_HOUR");
        // console.log(arrayLinks);
        commit("SET_ARRAY_LINKS", arrayLinks);
        commit("SET_ARRAY_ON", array_ON);
        commit("SET_ARRAY_UP", array_UP);
        commit("SET_ARRAY_DOWN", array_DOWN);
        commit("SET_ARRAY_OFF", array_OFF);
        commit("SET_ARRAY_OUT", array_OUT);
        commit("SET_METERS_ON", m_ON);
        commit("SET_METERS_UP", m_UP);
        commit("SET_METERS_DOWN", m_DOWN);
        commit("SET_METERS_OFF", m_OFF);
        commit("SET_METERS_OUT", m_OUT);

        let allStatus = [array_ON, array_OFF, array_OUT];
        commit("SET_ARRAY_ALL", allStatus);

        let min = Math.min(...arrayWatts);
        let max = Math.max(...arrayWatts);
        let div = 6;
        let sum = min;
        let delta = (max - min) / div;
        arrayValues.push(min);
        for (let index = 0; index < div; index++) {
          sum += delta;
          arrayValues.push(Number(sum.toFixed(2)));
        }
        commit("SET_WATTS_ARRAY", arrayValues);

        let arr01W = [];
        let arr12W = [];
        let arr23W = [];
        let arr34W = [];
        let arr45W = [];
        let arr56W = [];
        let arr01S = [];
        let arr12S = [];
        let arr23S = [];
        let arr34S = [];
        let arr45S = [];
        let arr56S = [];
        let arr67S = [];
        let arr78S = [];
        let arr89S = [];
        let arr910S = [];
        let arraySignals = state.signals;
        let element;
        for (let index = 0; index < arrDevWatts.length; index++) {
          element = arrDevWatts[index];
          if (
            element.watts >= arrayValues[0] &&
            element.watts <= arrayValues[1]
          ) {
            let e01 = state.meters.find((m) => m.name === element.meter);
            arr01W.push(e01);
          } else if (
            element.watts > arrayValues[1] &&
            element.watts <= arrayValues[2]
          ) {
            let e12 = state.meters.find((m) => m.name === element.meter);
            arr12W.push(e12);
          } else if (
            element.watts > arrayValues[2] &&
            element.watts <= arrayValues[3]
          ) {
            let e23 = state.meters.find((m) => m.name === element.meter);
            arr23W.push(e23);
          } else if (
            element.watts > arrayValues[3] &&
            element.watts <= arrayValues[4]
          ) {
            let e34 = state.meters.find((m) => m.name === element.meter);
            arr34W.push(e34);
          } else if (
            element.watts > arrayValues[4] &&
            element.watts <= arrayValues[5]
          ) {
            let e45 = state.meters.find((m) => m.name === element.meter);
            arr45W.push(e45);
          } else {
            let e56 = state.meters.find((m) => m.name === element.meter);
            arr56W.push(e56);
          }

          element = arrDevSignals[index];
          if (
            element.signal >= arraySignals[0] &&
            element.signal <= arraySignals[1]
          ) {
            let e01 = state.meters.find((m) => m.name === element.meter);
            arr01S.push(e01);
          } else if (
            element.signal > arraySignals[1] &&
            element.signal <= arraySignals[2]
          ) {
            let e12 = state.meters.find((m) => m.name === element.meter);
            arr12S.push(e12);
          } else if (
            element.signal > arraySignals[2] &&
            element.signal <= arraySignals[3]
          ) {
            let e23 = state.meters.find((m) => m.name === element.meter);
            arr23S.push(e23);
          } else if (
            element.signal > arraySignals[3] &&
            element.signal <= arraySignals[4]
          ) {
            let e34 = state.meters.find((m) => m.name === element.meter);
            arr34S.push(e34);
          } else if (
            element.signal > arraySignals[4] &&
            element.signal <= arraySignals[5]
          ) {
            let e45 = state.meters.find((m) => m.name === element.meter);
            arr45S.push(e45);
          } else if (
            element.signal > arraySignals[5] &&
            element.signal <= arraySignals[6]
          ) {
            let e56 = state.meters.find((m) => m.name === element.meter);
            arr56S.push(e56);
          } else if (
            element.signal > arraySignals[6] &&
            element.signal <= arraySignals[7]
          ) {
            let e67 = state.meters.find((m) => m.name === element.meter);
            arr67S.push(e67);
          } else if (
            element.signal > arraySignals[7] &&
            element.signal <= arraySignals[8]
          ) {
            let e78 = state.meters.find((m) => m.name === element.meter);
            arr78S.push(e78);
          } else if (
            element.signal > arraySignals[8] &&
            element.signal <= arraySignals[9]
          ) {
            let e89 = state.meters.find((m) => m.name === element.meter);
            arr89S.push(e89);
          } else {
            let e910 = state.meters.find((m) => m.name === element.meter);
            arr910S.push(e910);
          }
        }

        let allRangesSignals = [
          arr01S,
          arr12S,
          arr23S,
          arr34S,
          arr45S,
          arr56S,
          arr67S,
          arr78S,
          arr89S,
          arr910S,
        ];
        commit("SET_RANGES_SIGNALS_ARRAY", allRangesSignals);

        let allRangesWatts = [arr01W, arr12W, arr23W, arr34W, arr45W, arr56W];
        commit("SET_RANGES_WATTS_ARRAY", allRangesWatts);

        return resolve();
      } catch (error) {
        // commit('UPDATE_LAST_READS', null)
        console.log(error);
        return reject();
        // return true
        // return
      }
    });
  },
  lastReadingById({ state, commit }, id) {
    return new Promise(async (resolve, reject) => {
      try {
        let { data } = await Readings.last([id]);

        // console.log(data);
        commit(
          "UPDATE_LAST_READS",
          data.map((record) => record[0])
        );
        // commit('UPDATE_LAST_READS', [])
        let arrayWatts = [];
        let arrayValues = [];
        let arrDevWatts = [];
        let arrDevSignals = [];
        let array_ON = [];
        let array_UP = [];
        let array_DOWN = [];
        let array_OFF = [];
        let array_OUT = [];
        let userData = await state.userInfo.get();
        // console.log(userData.data());
        let minToDgr = userData.data().minutesToDanger;
        let m_ON = 0;
        let m_UP = 0;
        let m_DOWN = 0;
        let m_OFF = 0;
        let m_OUT = 0;
        let arrayLinks = [];
        let arrayGroups = [];
        let groupNames = [];
        let finalGroups = [];
        // console.log(data);
        for (let index = 0; index < data.length; index++) {
          let element = data[index][0];
          // console.log(element);
          if (element != undefined) {
            let time =
              new Date().getTime() - new Date(element.timestamp).getTime();
            let m = Math.abs(
              element.lines.reduce((suma, l) => suma + l.watts, 0).toFixed(2)
            );
            // console.log(m);
            let circuit = state.meters.find((m) => m.name === element.meter);
            // console.log(circuit);
            let device = circuit.name; // nombre del medidor
            let obw = { meter: device, watts: m };
            arrDevWatts.push(obw);
            let rssi = Math.abs(element.status.rssi);
            let obr = { meter: device, signal: rssi };
            arrDevSignals.push(obr);
            if (circuit.link != undefined) {
              let obj = {
                name: circuit.circuit,
                url: circuit.link,
                id: circuit.name,
              };
              arrayLinks.push(obj);
            } else {
              let lat = circuit.location.latitude;
              let lng = circuit.location.longitude;
              const d = await fetch(
                `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${process.env.VUE_APP_FB_API_KEY}`
              );
              const d_json = await d.json();
              let address = null;
              let obj = {};
              if (d_json.hasOwnProperty("plus_code")) {
                address = d_json.plus_code.global_code;
                let arr_add = address.split("");
                let arr_new = [];
                for (let index = 0; index < arr_add.length; index++) {
                  const element = arr_add[index];
                  if (element != "+") {
                    arr_new.push(element);
                  } else {
                    let prov = "%2B";
                    arr_new.push(prov);
                  }
                }
                let arr_join = arr_new.join("");
                let gMapLink = `https://www.google.com/maps/place/${arr_join}`;
                obj = {
                  name: circuit.circuit,
                  url: gMapLink,
                  id: circuit.name,
                };
                arrayLinks.push(obj);
              } else {
                address = "N/A";
                obj = { name: circuit.circuit, url: address };
                arrayLinks.push(obj);
              }

              await db
                .doc(`${state.collection}/${circuit.name}`)
                .update({ link: obj.url });
            }

            if (circuit.device_type == undefined) {
              await db
                .doc(`${state.collection}/${circuit.name}`)
                .update({ device_type: "smart_controller" });
            }

            let limOff = Number(circuit.capacity);
            let limUp = limOff + limOff * 0.1;
            let limDown = limOff - limOff * 0.1;
            let limReg = limOff - limOff * 0.95;
            if (minToDgr * 60 * 1000 < time) {
              m_OUT += 1;
              let e_OUT = state.meters.find((m) => m.name === element.meter);
              // console.log(e_OUT);
              array_OUT.push(e_OUT);
            } else if (m < limReg) {
              m_OFF += 1;
              let e_OFF = state.meters.find((m) => m.name === element.meter);
              // console.log(e_OFF);
              array_OFF.push(e_OFF);
            } else if (m >= limReg && m < limDown) {
              m_DOWN += 1;
              m_ON += 1;
              let e_DOWN = state.meters.find((m) => m.name === element.meter);
              // console.log(e_DOWN);
              array_DOWN.push(e_DOWN);
              array_ON.push(e_DOWN);
            } else if (m >= limDown && m < limUp) {
              m_ON += 1;
              let e_ON = state.meters.find((m) => m.name === element.meter);
              array_ON.push(e_ON);
            } else if (m >= limUp) {
              m_UP += 1;
              m_ON += 1;
              let e_UP = state.meters.find((m) => m.name === element.meter);
              array_UP.push(e_UP);
              array_ON.push(e_UP);
            }
            arrayWatts.push(m);
          }
        }
        commit("SET_DATA_WATTS", arrDevWatts);
        commit("SET_DATA_SIGNAL", arrDevSignals);

        commit("SET_ACTUAL_HOUR");
        // console.log(arrayLinks);
        commit("SET_ARRAY_LINKS", arrayLinks);
        commit("SET_ARRAY_ON", array_ON);
        commit("SET_ARRAY_UP", array_UP);
        commit("SET_ARRAY_DOWN", array_DOWN);
        commit("SET_ARRAY_OFF", array_OFF);
        commit("SET_ARRAY_OUT", array_OUT);
        commit("SET_METERS_ON", m_ON);
        commit("SET_METERS_UP", m_UP);
        commit("SET_METERS_DOWN", m_DOWN);
        commit("SET_METERS_OFF", m_OFF);
        commit("SET_METERS_OUT", m_OUT);

        let allStatus = [array_ON, array_OFF, array_OUT];
        commit("SET_ARRAY_ALL", allStatus);

        let min = Math.min(...arrayWatts);
        let max = Math.max(...arrayWatts);
        let div = 6;
        let sum = min;
        let delta = (max - min) / div;
        arrayValues.push(min);
        for (let index = 0; index < div; index++) {
          sum += delta;
          arrayValues.push(Number(sum.toFixed(2)));
        }
        commit("SET_WATTS_ARRAY", arrayValues);

        let arr01W = [];
        let arr12W = [];
        let arr23W = [];
        let arr34W = [];
        let arr45W = [];
        let arr56W = [];
        let arr01S = [];
        let arr12S = [];
        let arr23S = [];
        let arr34S = [];
        let arr45S = [];
        let arr56S = [];
        let arr67S = [];
        let arr78S = [];
        let arr89S = [];
        let arr910S = [];
        let arraySignals = state.signals;
        let element;
        for (let index = 0; index < arrDevWatts.length; index++) {
          element = arrDevWatts[index];
          if (
            element.watts >= arrayValues[0] &&
            element.watts <= arrayValues[1]
          ) {
            let e01 = state.meters.find((m) => m.name === element.meter);
            arr01W.push(e01);
          } else if (
            element.watts > arrayValues[1] &&
            element.watts <= arrayValues[2]
          ) {
            let e12 = state.meters.find((m) => m.name === element.meter);
            arr12W.push(e12);
          } else if (
            element.watts > arrayValues[2] &&
            element.watts <= arrayValues[3]
          ) {
            let e23 = state.meters.find((m) => m.name === element.meter);
            arr23W.push(e23);
          } else if (
            element.watts > arrayValues[3] &&
            element.watts <= arrayValues[4]
          ) {
            let e34 = state.meters.find((m) => m.name === element.meter);
            arr34W.push(e34);
          } else if (
            element.watts > arrayValues[4] &&
            element.watts <= arrayValues[5]
          ) {
            let e45 = state.meters.find((m) => m.name === element.meter);
            arr45W.push(e45);
          } else {
            let e56 = state.meters.find((m) => m.name === element.meter);
            arr56W.push(e56);
          }

          element = arrDevSignals[index];
          if (
            element.signal >= arraySignals[0] &&
            element.signal <= arraySignals[1]
          ) {
            let e01 = state.meters.find((m) => m.name === element.meter);
            arr01S.push(e01);
          } else if (
            element.signal > arraySignals[1] &&
            element.signal <= arraySignals[2]
          ) {
            let e12 = state.meters.find((m) => m.name === element.meter);
            arr12S.push(e12);
          } else if (
            element.signal > arraySignals[2] &&
            element.signal <= arraySignals[3]
          ) {
            let e23 = state.meters.find((m) => m.name === element.meter);
            arr23S.push(e23);
          } else if (
            element.signal > arraySignals[3] &&
            element.signal <= arraySignals[4]
          ) {
            let e34 = state.meters.find((m) => m.name === element.meter);
            arr34S.push(e34);
          } else if (
            element.signal > arraySignals[4] &&
            element.signal <= arraySignals[5]
          ) {
            let e45 = state.meters.find((m) => m.name === element.meter);
            arr45S.push(e45);
          } else if (
            element.signal > arraySignals[5] &&
            element.signal <= arraySignals[6]
          ) {
            let e56 = state.meters.find((m) => m.name === element.meter);
            arr56S.push(e56);
          } else if (
            element.signal > arraySignals[6] &&
            element.signal <= arraySignals[7]
          ) {
            let e67 = state.meters.find((m) => m.name === element.meter);
            arr67S.push(e67);
          } else if (
            element.signal > arraySignals[7] &&
            element.signal <= arraySignals[8]
          ) {
            let e78 = state.meters.find((m) => m.name === element.meter);
            arr78S.push(e78);
          } else if (
            element.signal > arraySignals[8] &&
            element.signal <= arraySignals[9]
          ) {
            let e89 = state.meters.find((m) => m.name === element.meter);
            arr89S.push(e89);
          } else {
            let e910 = state.meters.find((m) => m.name === element.meter);
            arr910S.push(e910);
          }
        }

        let allRangesSignals = [
          arr01S,
          arr12S,
          arr23S,
          arr34S,
          arr45S,
          arr56S,
          arr67S,
          arr78S,
          arr89S,
          arr910S,
        ];
        commit("SET_RANGES_SIGNALS_ARRAY", allRangesSignals);

        let allRangesWatts = [arr01W, arr12W, arr23W, arr34W, arr45W, arr56W];
        commit("SET_RANGES_WATTS_ARRAY", allRangesWatts);

        return resolve();
      } catch (error) {
        // commit('UPDATE_LAST_READS', null)
        console.log(error);
        return reject();
        // return true
        // return
      }
    });
  },
  async valuesTemps({ state, rootState, commit }) {
    try {
      const userData = await state.userInfo.get();
      const city = userData.data().city;
      const apiData = await fetch(
        `https://api.openweathermap.org/data/2.5/weather?q=${city},mx&appid=${state.key}`
      );
      const apiRes = await apiData.json();
      let h = Math.round(apiRes.main.humidity);
      let t = await Math.round(((apiRes.main.temp - 273.15) * 9) / 5 + 32);
      let arrTemp = [];
      let tValues = [];
      let arrLight = [];
      let lValues = [];
      let arrHumid = [];
      let hValues = [];

      for (let index = 0; index < state.meters.length; index++) {
        const element = state.meters[index];
        const m = element.circuit;
        let obj = {};
        let obj2 = {};
        let obj3 = {};
        const data = null;
        if (data.data.temperature) {
          if (
            data.data.temperature.lastValue > 0 &&
            data.data.temperature.lastValue <= 55
          ) {
            let tempF = Number(
              ((data.data.temperature.lastValue * 9) / 5 + 32).toFixed(0)
            );
            tValues.push(tempF);
            obj = { meter: m, temp: tempF };
          } else {
            let tempD = Number(t);
            tValues.push(tempD);
            obj = { meter: m, temp: tempD };
          }
        } else {
          let tempD = Number(t);
          tValues.push(tempD);
          obj = { meter: m, temp: tempD };
        }
        if (data.data.light != undefined) {
          if (data.data.light.lastValue > 100) {
            obj2 = { meter: m, light: 100 };
            lValues.push(100);
          } else {
            obj2 = { meter: m, light: data.data.light.lastValue };
            lValues.push(data.data.light.lastValue);
          }
        } else {
          obj2 = { meter: m, light: 0 };
          lValues.push(0);
        }

        if (data.data.humidity != undefined) {
          if (data.data.humidity.lastValue === null) {
            obj3 = { meter: m, humidity: h };
            hValues.push(h);
          } else {
            obj3 = { meter: m, humidity: data.data.humidity.lastValue };
            hValues.push(data.data.humidity.lastValue);
          }
        } else {
          obj3 = { meter: m, humidity: h };
          hValues.push(h);
        }
        arrTemp.push(obj);
        arrLight.push(obj2);
        arrHumid.push(obj3);
      }

      commit("SET_TEMPS_ARRAY", arrTemp);
      commit("SET_HUMID_ARRAY", arrHumid);
      commit("SET_LIGHT_ARRAY", arrLight);
      let div = 6;
      let valTemp = [];
      let minT = Math.min(...tValues);
      let maxT = Math.max(...tValues);
      let sumT = minT;
      let deltaT = (maxT - minT) / div;
      let arr01T = [];
      let arr12T = [];
      let arr23T = [];
      let arr34T = [];
      let arr45T = [];
      let arr56T = [];
      valTemp.push(minT);
      for (let index = 0; index < div; index++) {
        sumT += deltaT;
        valTemp.push(Number(sumT.toFixed(0)));
      }
      commit("SET_VAL_TEMPS_ARRAY", valTemp);
      for (let index = 0; index < arrTemp.length; index++) {
        const element = arrTemp[index];
        if (element.temp >= valTemp[0] && element.temp <= valTemp[1]) {
          let e01 = state.meters.find((m) => m.circuit === element.meter);
          arr01T.push(e01);
        } else if (element.temp > valTemp[1] && element.temp <= valTemp[2]) {
          let e12 = state.meters.find((m) => m.circuit === element.meter);
          arr12T.push(e12);
        } else if (element.temp > valTemp[2] && element.temp <= valTemp[3]) {
          let e23 = state.meters.find((m) => m.circuit === element.meter);
          arr23T.push(e23);
        } else if (element.temp > valTemp[3] && element.temp <= valTemp[4]) {
          let e34 = state.meters.find((m) => m.circuit === element.meter);
          arr34T.push(e34);
        } else if (element.temp > valTemp[4] && element.temp <= valTemp[5]) {
          let e45 = state.meters.find((m) => m.circuit === element.meter);
          arr45T.push(e45);
        } else {
          let e56 = state.meters.find((m) => m.circuit === element.meter);
          arr56T.push(e56);
        }
      }
      let allRangesTemp = [arr01T, arr12T, arr23T, arr34T, arr45T, arr56T];
      commit("SET_RANGES_TEMPS_ARRAY", allRangesTemp);

      let valHumid = [];
      let minH = Math.min(...hValues);
      let maxH = Math.max(...hValues);
      let sumH = minH;
      let deltaH = (maxH - minH) / div;
      let arr01H = [];
      let arr12H = [];
      let arr23H = [];
      let arr34H = [];
      let arr45H = [];
      let arr56H = [];
      valHumid.push(minH);
      for (let index = 0; index < div; index++) {
        sumH += deltaH;
        valHumid.push(Number(sumH.toFixed(0)));
      }
      commit("SET_VAL_HUMID_ARRAY", valHumid);
      for (let index = 0; index < arrHumid.length; index++) {
        const element = arrHumid[index];
        if (
          element.humidity >= valHumid[0] &&
          element.humidity <= valHumid[1]
        ) {
          let e01 = state.meters.find((m) => m.circuit === element.meter);
          arr01H.push(e01);
        } else if (
          element.humidity > valHumid[1] &&
          element.humidity <= valHumid[2]
        ) {
          let e12 = state.meters.find((m) => m.circuit === element.meter);
          arr12H.push(e12);
        } else if (
          element.humidity > valHumid[2] &&
          element.humidity <= valHumid[3]
        ) {
          let e23 = state.meters.find((m) => m.circuit === element.meter);
          arr23H.push(e23);
        } else if (
          element.humidity > valHumid[3] &&
          element.humidity <= valHumid[4]
        ) {
          let e34 = state.meters.find((m) => m.circuit === element.meter);
          arr34H.push(e34);
        } else if (
          element.humidity > valHumid[4] &&
          element.humidity <= valHumid[5]
        ) {
          let e45 = state.meters.find((m) => m.circuit === element.meter);
          arr45H.push(e45);
        } else {
          let e56 = state.meters.find((m) => m.circuit === element.meter);
          arr56H.push(e56);
        }
      }
      let allRangesHumid = [arr01H, arr12H, arr23H, arr34H, arr45H, arr56H];
      commit("SET_RANGES_HUMID_ARRAY", allRangesHumid);

      let valLight = [];
      let minL = Math.min(...lValues);
      let maxL = Math.max(...lValues);
      let sumL = minL;
      let deltaL = (maxL - minL) / div;
      let arr01L = [];
      let arr12L = [];
      let arr23L = [];
      let arr34L = [];
      let arr45L = [];
      let arr56L = [];
      valLight.push(minL);
      for (let index = 0; index < div; index++) {
        sumL += deltaL;
        valLight.push(Number(sumL.toFixed(0)));
      }
      commit("SET_VAL_LIGHT_ARRAY", valLight);
      for (let index = 0; index < arrLight.length; index++) {
        const element = arrLight[index];
        if (element.light >= valLight[0] && element.light <= valLight[1]) {
          let e01 = state.meters.find((m) => m.circuit === element.meter);
          arr01L.push(e01);
        } else if (
          element.light > valLight[1] &&
          element.light <= valLight[2]
        ) {
          let e12 = state.meters.find((m) => m.circuit === element.meter);
          arr12L.push(e12);
        } else if (
          element.light > valLight[2] &&
          element.light <= valLight[3]
        ) {
          let e23 = state.meters.find((m) => m.circuit === element.meter);
          arr23L.push(e23);
        } else if (
          element.light > valLight[3] &&
          element.light <= valLight[4]
        ) {
          let e34 = state.meters.find((m) => m.circuit === element.meter);
          arr34L.push(e34);
        } else if (
          element.light > valLight[4] &&
          element.light <= valLight[5]
        ) {
          let e45 = state.meters.find((m) => m.circuit === element.meter);
          arr45L.push(e45);
        } else {
          let e56 = state.meters.find((m) => m.circuit === element.meter);
          arr56L.push(e56);
        }
      }
      let allRangesLight = [arr01L, arr12L, arr23L, arr34L, arr45L, arr56L];
      commit("SET_RANGES_LIGHT_ARRAY", allRangesLight);
    } catch (error) {
      console.log(error);
    }
  },
  filteredMeters({ state, commit }, data) {
    let metersFiltered = [];
    switch (data) {
      case "ON":
        metersFiltered = state.arrayON;
        break;
      case "OFF":
        metersFiltered = state.arrayOFF;
        break;
      case "OUT":
        metersFiltered = state.arrayOUT;
        break;
      default:
        metersFiltered = state.meters;
        break;
    }
    commit("FILTER_METERS", metersFiltered);
  },
  async metersLinks({ state, commit }) {
    let linksArray = [];
    for (let index = 0; index < state.meters.length; index++) {
      let m = state.meters[index].circuit;
      let lat = state.meters[index].location.latitude;
      let lng = state.meters[index].location.longitude;
      let name = state.meters[index].name;
      let response = await db.collection(state.collection).doc(name).get();
      let data = response.data();
      if (data.link != undefined) {
        let obj = { name: m, url: data.link };
        linksArray.push(obj);
      } else {
        const data = await fetch(
          `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${process.env.VUE_APP_FB_API_KEY}`
        );
        const data_json = await data.json();
        let address = null;
        let obj = {};
        if (data_json.hasOwnProperty("plus_code")) {
          address = data_json.plus_code.global_code;
          let arr_add = address.split("");
          let arr_new = [];
          for (let index = 0; index < arr_add.length; index++) {
            const element = arr_add[index];
            if (element != "+") {
              arr_new.push(element);
            } else {
              let prov = "%2B";
              arr_new.push(prov);
            }
          }
          let arr_join = arr_new.join("");
          let gMapLink = `https://www.google.com/maps/place/${arr_join}`;
          obj = { name: m, url: gMapLink };
          linksArray.push(obj);
        } else {
          address = "N/A";
          obj = { name: m, url: address };
          linksArray.push(obj);
        }
        await db.doc(`${state.collection}/${name}`).update({
          link: obj.url,
        });
      }
    }
    commit("SET_ARRAY_LINKS", linksArray);
  },
  async valuesWatts({ state, commit }) {
    let { data } = await Readings.byMeter(
      { id: state.meters[2].name, key: state.meters[2].key },
      { cnt: 60 }
    );
  },
  queryReadings({ state }, data) {
    const meter = state.meters.find((m) => m.name === data.meter);
    if (!meter) {
      return [];
    }
    return new Promise((resolve, reject) => {
      Readings.byMeter({ id: meter.name, key: meter.key }, data.query)
        .then((response) => {
          const { data } = response;
          console.log(data);

          resolve(data);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },
  updateMeterData({ state, commit }, id_meter) {
    const meter = state.meters.find((m) => m.name === id_meter);
    console.log("Updating meter data", meter);

    const MINUTES_REFRESH = 15;
    if (meter.data)
      if (
        meter.data.length > 0 &&
        new Date().getTime() - meter.last_update < 1000 * 60 * MINUTES_REFRESH
      )
        return false;

    return new Promise((resolve, reject) => {
      Readings.byMeter(
        { id: meter.name, key: meter.key },
        {
          end: new Date().getTime(),
          start: new Date().getTime() - 1000 * 60 * 60 * 24,
        }
      )
        .then((response) => {
          const { data } = response;
          for (let i = 0; i < data.length; i++) {
            data[i].lines[0].watts = Math.abs(data[i].lines[0].watts);
            data[i].lines[1].watts = Math.abs(data[i].lines[1].watts);
            data[i].lines[0].amps = Math.abs(data[i].lines[0].amps);
            data[i].lines[1].amps = Math.abs(data[i].lines[1].amps);
          }
          commit("SET_METER_DATA", { meter: id_meter, data: data });
          resolve(true);
        })
        .catch((error) => {
          console.log(error);
          reject(false);
        });
    });
  },
  async getHistoricData({ state, dispatch }, data) {
    let meter = state.meters.find((m) => m.name === data.id_meter);
    if (!meter) meter = JSON.parse(localStorage.getItem("meter"));
    return new Promise((resolve, reject) => {
      Readings.daySummary(meter.name, {
        start:
          data.start || new Date().getTime() - 1000 * 60 * 60 * 24 * data.days,
        end: data.end || new Date().getTime(),
      })
        .then((response) => {
          const data = response;
          for (let i = 0; i < data.length; i++) {
            data[i].lines[0].kwht = Math.abs(data[i].lines[0].kwht);
            {
            }
          }
          resolve({ data });
        })
        .catch((error) => {
          console.log(error);
          reject({ data: [] });
        });
    });
  },
  async newComment({ state, commit }, data) {
    try {
      let { name, content, date, creationDate } = data;
      const comm = await db
        .collection(state.collection)
        .doc(name)
        .collection("comments")
        .add({
          content: content,
          date: date,
          creationDate: creationDate,
        });
      let comment = {
        content: content,
        date: date,
      };
      commit("INSERT_COMMENT", comment);
    } catch (error) {
      console.log(error);
    }
  },
  async getComments({ state, commit }, meter) {
    let comments = [];

    if (state.collection != null) {
      localStorage.setItem("collection", JSON.stringify(state.collection));
      await db
        .collection(state.collection)
        .doc(meter)
        .collection("comments")
        .orderBy("creationDate", "desc")
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            comments.push(doc.data());
          });
          commit("DISPLAY_COMMENTS", comments);
        });
    } else {
      state.collection = JSON.parse(localStorage.getItem("collection"));
      await db
        .collection(state.collection)
        .doc(meter)
        .collection("comments")
        .orderBy("creationDate", "desc")
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            comments.push(doc.data());
          });
          commit("DISPLAY_COMMENTS", comments);
        });
    }
  },
  async retrieveAllComments({ state, commit }) {
    let comments = [];
    let order = [];
    let counter = 0;
    let commMeter = state.meters;
    for (let i = 0; i < commMeter.length; i++) {
      const element1 = commMeter[i];
      let comm = await db
        .collection(state.collection)
        .doc(element1.name)
        .collection("comments")
        .orderBy("creationDate", "desc")
        .get();
      let c = comm.docs.map((m) => m.data());
      let obj = {
        name: element1.name,
        comments: c,
      };
      comments.push(obj);
    }
    commit("RETRIEVE_COMMENTS", comments);
  },
  async deleteComment({ state, commit }, data) {
    let { name, creationDate } = data;
    let res = await db
      .collection(state.collection)
      .doc(name)
      .collection("comments")
      .where("creationDate", "==", creationDate);
    let foundComm = res.get().then((querySnapshot) => {
      querySnapshot.forEach((doc) => {
        let id = doc.id;
        let res_del = db
          .collection(state.collection)
          .doc(name)
          .collection("comments")
          .doc(id);
        res_del.delete();
        commit("DELETE_COMMENT", creationDate);
      });
    });
  },
  async createNewGroup({ state, commit, rootState }, data) {
    let { name, meters } = data;
    await meters.forEach((element) => {
      db.doc(`${state.collection}/${element.name}`).update({ group: name });
    });
    let arr = state.groupMeters;
    let id = name.toLowerCase().replace(/\s+/g, "");
    let obj = {
      name: name,
      id: id,
      meters: meters,
      control: false,
      photocell: false,
      suntime: false,
      timeON: "00:00",
      timeOFF: "00:00",
    };
    arr.push(obj);
    await db.doc(`users/${rootState.user.userID}/groups/${name}`).set({
      name: obj.name,
      control: obj.control,
      photocell: obj.photocell,
      suntime: obj.suntime,
      timeON: obj.timeON,
      timeOFF: obj.timeOFF,
    });
    commit("SET_GROUPS", arr);
  },
  async editGroup({ state, commit, rootState }, data) {
    await data.newMeters.forEach((element) => {
      db.doc(`${state.collection}/${element.name}`).update({
        group: data.newName,
      });
    });
    let arr = state.groupMeters;
    let group = arr.find((m) => m.name === data.name);
    let id = data.name.toLowerCase().replace(/\s+/g, "");
    group.name = data.newName;
    group.meters = data.newMeters;
    group.id = id;
    arr = arr.filter((item) => item.name !== data.name);
    arr.push(group);
    let idx = arr.findIndex((m) => m.name === data.newName);
    await db.doc(`users/${rootState.user.userID}/groups/${data.name}`).delete();
    await db.doc(`users/${rootState.user.userID}/groups/${data.newName}`).set({
      name: data.newName,
      control: arr[idx].control,
      photocell: arr[idx].photocell,
      suntime: arr[idx].suntime,
      timeON: arr[idx].timeON,
      timeOFF: arr[idx].timeOFF,
    });
  },
  async deleteFromGroup({ state, commit }, data) {
    await data.meters.forEach((element) => {
      db.doc(`${state.collection}/${element.name}`).update({
        group: firebase.firestore.FieldValue.delete(),
      });
    });
  },
  async deleteGroup({ state, commit, rootState }, data) {
    await data.meters.forEach((element) => {
      db.doc(`${state.collection}/${element.name}`).update({
        group: firebase.firestore.FieldValue.delete(),
      });
    });
    let arr = state.groupMeters;
    arr = arr.filter((item) => item.name !== data.name);
    await db.doc(`users/${rootState.user.userID}/groups/${data.name}`).delete();
    commit("SET_GROUPS", arr);
  },
  async editGroupDataControl({ state, rootState }, data) {
    let { n, type, active, g } = data;
    let idx = state.groupMeters.findIndex((m) => m.name === g.name);
    switch (type) {
      case "control":
        await db
          .doc(`users/${rootState.user.userID}/groups/${n}`)
          .update({ control: active });
        state.groupMeters[idx].control = active;
        break;
      case "photocell":
        await db
          .doc(`users/${rootState.user.userID}/groups/${n}`)
          .update({ photocell: active });
        state.groupMeters[idx].photocell = active;
        break;
      case "suntime":
        await db
          .doc(`users/${rootState.user.userID}/groups/${n}`)
          .update({ suntime: active });
        state.groupMeters[idx].suntime = active;
        break;
      default:
        break;
    }
  },
  async setDeviceType({ state, commit }, data) {
    let { m, dt } = data;
    return new Promise(async (resolve, reject) => {
      try {
        let meter_id = m.name;
        let index = state.meters.findIndex((n) => n.name == meter_id);
        if (dt === "smart_node") {
          let response = await db
            .collection(state.collection)
            .doc(meter_id)
            .update({
              device_type: dt,
              node_level: 0,
            });
        } else {
          let response = await db
            .collection(state.collection)
            .doc(meter_id)
            .update({
              device_type: dt,
            });
        }
        commit("SET_DEVICE_TYPE", { meter_id, index, dt });
        resolve();
      } catch (error) {
        reject();
      }
    });
  },
  async setNodeLevel({ state, commit }, data) {
    let { m, l } = data;
    return new Promise(async (resolve, reject) => {
      try {
        let meter_id = m.name;
        let index = state.meters.findIndex((n) => n.name == meter_id);
        let response = await db
          .collection(state.collection)
          .doc(meter_id)
          .update({
            node_level: l,
          });
        await Meter.dimmer(meter_id, data.l);
        commit("SET_NODE_LEVEL", { meter_id, index, l });
        resolve();
      } catch (error) {
        reject();
      }
    });
  },
  async editGroupSchedules({ state, rootState }, data) {
    let { n, type, hh, mm, g, diff } = data;
    let idx = state.groupMeters.findIndex((m) => m.name === g.name);
    let hour = hh + ":" + mm;
    let hhDiff = Number(hh);
    hhDiff += diff;
    if (hhDiff < 0) {
      hhDiff += 24;
    }
    hhDiff = ("0" + hhDiff).slice(-2);
    let hourDiff = hhDiff + ":" + mm;
    switch (type) {
      case "on":
        await db
          .doc(`users/${rootState.user.userID}/groups/${n}`)
          .update({ timeON: hour });
        state.groupMeters[idx].timeON = hour;
        break;
      case "off":
        await db
          .doc(`users/${rootState.user.userID}/groups/${n}`)
          .update({ timeOFF: hour });
        state.groupMeters[idx].timeOFF = hour;
        break;
      default:
        break;
    }
  },
  async resetMeters({ commit }) {
    await commit("SET_METERS", []);
    await commit("SET_METERS_ON", undefined);
    await commit("SET_METERS_OFF", undefined);
    await commit("SET_METERS_OUT", undefined);
    await commit("SET_METERS_UP", undefined);
    await commit("SET_METERS_DOWN", undefined);
    await commit("SET_ARRAY_ON", []);
    await commit("SET_ARRAY_OFF", []);
    await commit("SET_ARRAY_OUT", []);
    await commit("SET_ARRAY_UP", []);
    await commit("SET_ARRAY_DOWN", []);
  },
};

const mutations = {
  UPDATE_COLLECTION(state, user) {
    user
      ? (state.collection = `users/${user}/meters`)
      : (state.collection = null);
    // console.log(state.collection);
  },
  UPDATE_USER_INFO(state, user) {
    user ? (state.userInfo = db.doc(`users/${user}`)) : (state.userInfo = null);
    // console.log(state.userInfo.get());
  },
  UPDATE_TOKEN(state, token) {
    state.token = token;
    // console.log(token);
  },
  UPDATE_LAST_READS(state, data) {
    state.lastReadings = data;
  },
  SET_WATTS_ARRAY(state, data) {
    state.watts = data;
  },
  SET_DATA_WATTS(state, data) {
    state.wattsData = data;
  },
  SET_RANGES_WATTS_ARRAY(state, data) {
    state.rangeArrayWatts = data;
  },
  SET_DATA_SIGNAL(state, data) {
    state.signalData = data;
  },
  SET_RANGES_SIGNALS_ARRAY(state, data) {
    state.rangeArraySignals = data;
  },
  SET_METER_DATA(state, payload) {
    const index = state.meters.findIndex((m) => m.name == payload.meter);
    state.meters[index].data = payload.data;
    state.meters[index].last_update = new Date().getTime();
  },
  UPDATE_METER(state, payload) {
    if (payload.index < 0) return;
    let meter = state.meters[payload.index];
    meter.circuit = payload.meter.circuit;
    meter.location = payload.meter.location;
    meter.capacity = payload.meter.capacity;
    meter.link = payload.meter.link;
    state.meters[payload.index] = meter;
  },
  UPDATE_METER_API(state, payload) {
    // console.log(payload);
    const propToUpdate = [
      "active",
      "control",
      "currentVersion",
      "fotocelda",
      "meter_id",
      "schedule",
      "sim_id",
      "suntime",
      "level",
      "controlStatus",
    ];
    const index = state.meters.findIndex((m) => m.name === payload.name);
    if (index === -1) return;
    propToUpdate.forEach((prop) => {
      if (payload.hasOwnProperty(prop))
        state.meters[index][prop] = payload[prop];
      state.metersAPI.push(state.meters[index][prop]);
    });
  },
  UPDATE_METER_STATUS(state, payload) {
    const index = state.meters.findIndex((m) => m.name === payload.meter);
    if (index === -1) return;
    state.meters[index].active = payload.active;
    state.meters[index].control = payload.control;
  },
  SET_GROUPS(state, value) {
    state.groupMeters = value;
  },
  EDIT_GROUPS(state, value) {
    return state.groupMeters;
  },
  ADD_NEW_GROUP(state, value) {
    state.groupMeters.push(value);
    return state.groupMeters;
  },
  SET_METERS_ON(state, value) {
    state.metersON = value;
  },
  SET_METERS_UP(state, value) {
    state.metersUP = value;
  },
  SET_METERS_DOWN(state, value) {
    state.metersDOWN = value;
  },
  SET_METERS_OFF(state, value) {
    state.metersOFF = value;
  },
  SET_METERS_OUT(state, value) {
    state.metersOUT = value;
  },
  SET_ARRAY_ON(state, value) {
    state.arrayON = value;
  },
  SET_ARRAY_UP(state, value) {
    state.arrayUP = value;
  },
  SET_ARRAY_DOWN(state, value) {
    state.arrayDOWN = value;
  },
  SET_ARRAY_OFF(state, value) {
    state.arrayOFF = value;
  },
  SET_ARRAY_OUT(state, value) {
    state.arrayOUT = value;
  },
  SET_ARRAY_ALL(state, value) {
    state.arrayStatus = value;
  },
  FILTER_METERS(state, value) {
    state.currMeters = value;
  },
  SET_TEMPS_ARRAY(state, value) {
    state.arrayTemps = value;
  },
  SET_VAL_TEMPS_ARRAY(state, value) {
    state.rangeTemps = value;
  },
  SET_RANGES_TEMPS_ARRAY(state, value) {
    state.rangeArrayTemps = value;
  },
  SET_LIGHT_ARRAY(state, value) {
    state.arrayLights = value;
  },
  SET_VAL_LIGHT_ARRAY(state, value) {
    state.rangeLights = value;
  },
  SET_RANGES_LIGHT_ARRAY(state, value) {
    state.rangeArrayLights = value;
  },
  SET_HUMID_ARRAY(state, value) {
    state.arrayHumids = value;
  },
  SET_VAL_HUMID_ARRAY(state, value) {
    state.rangeHumids = value;
  },
  SET_RANGES_HUMID_ARRAY(state, value) {
    state.rangeArrayHumids = value;
  },
  SET_ARRAY_LINKS(state, value) {
    state.arrayMeterLinks = value;
  },
  UPDATE_METER_CONTROL(state, payload) {
    const index = state.meters.findIndex((m) => m.name === payload.meter);
    if (index === -1) return;
    state.meters[index].control = payload.control;
    state.meters[index].fotocelda = payload.fotocelda;
  },
  UPDATE_METER_SCHEDULE(state, payload) {
    const index = state.meters.findIndex((m) => m.name === payload.meter);
    if (index === -1) return;
    if (!state.meters[index].schedule) state.meters[index].schedule = {};
    if (payload.inactive) state.meters[index].schedule[payload.control] = null;
    else
      state.meters[index].schedule[payload.control] =
        payload.hours + ":" + payload.minutes;
  },
  UPDATE_METER_SUNTIME(state, payload) {
    const index = state.meters.findIndex((m) => m.name === payload.meter);
    if (index === -1) return;
    state.meters[index].suntime = payload.data.active;
  },
  SET_METERS(state, meters) {
    if (!meters) return;
    state.meters = meters;
    state.currMeters = meters;
    // console.log(state.meters);
  },
  ADD_METERS(state, meters) {
    if (!meters) return;
    state.meters.push(...meters);
    return state.meters;
  },
  DELETE_METER(state, payload) {
    state.meters = state.meters.filter((item) => item.circuit !== payload);
    return state.meters;
  },
  INSERT_COMMENT(state, comment) {
    state.comments.push(comment);
  },
  DISPLAY_COMMENTS(state, comments) {
    if (!comments) return;
    state.comments = comments;
  },
  RETRIEVE_COMMENTS(state, comments) {
    if (!comments) return;
    state.allComments = comments;
  },
  DELETE_COMMENT(state, payload) {
    state.comments = state.comments.filter(
      (item) => item.creationDate !== payload
    );
    return;
  },
  REPORT_ISSUE(state, payload) {
    if (payload.index < 0) return;
    let meter = state.meters[payload.index];
    payload.issue = meter.issue;
    state.meters[payload.index] = meter;
  },
  SET_DEVICE_TYPE(state, payload) {
    if (payload.index < 0) return;
    let meter = state.meters[payload.index];
    meter.device_type = payload.dt;
    if (payload.dt === "smart_node") meter.node_level = 0;
    state.meters[payload.index] = meter;
  },
  SET_NODE_LEVEL(state, payload) {
    if (payload.index < 0) return;
    let meter = state.meters[payload.index];
    meter.node_level = payload.l;
    state.meters[payload.index] = meter;
  },
  SET_ACTUAL_HOUR(state) {
    const utc = moment();
    const hour = utc.format("LTS");
    state.lastHour = moment(hour, "h:mm:ss A").format("HH:mm");
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
